export const MAX_MESSAGE_MEDIA = 10;

export const normalizeAttachments = (files) => Array.isArray(files) ? files : files ? [files] : [];

export const getAttachmentType = (file) => {
    const mime = String(file?.type || file?.mime_type || '').toLowerCase();
    for (const type of ['image', 'video', 'audio']) {
        if (mime === type || mime.startsWith(`${type}/`)) return type;
    }
    // Some browsers and old messages have no MIME type.
    const name = String(file?.name || file?.original || file?.original_name || file?.path || '').split(/[?#]/)[0];
    if (/\.(jpe?g|png|gif|webp|avif|heic|heif|bmp|svg)$/i.test(name)) return 'image';
    if (/\.(mp4|m4v|mov|webm|ogv|avi|mkv)$/i.test(name)) return 'video';
    if (/\.(mp3|wav|ogg|m4a|aac|flac)$/i.test(name)) return 'audio';
    return 'file';
};

export const countAttachmentMedia = (files) => normalizeAttachments(files)
    .filter((file) => ['image', 'video'].includes(getAttachmentType(file))).length;

// The API adds one file to an existing message. Keep ordering and one message id
// for the entire album, including retries after a partially successful upload.
export const uploadMessageAttachments = async ({ files, upload, onUploaded, onProgress }) => {
    const attachments = normalizeAttachments(files);
    for (let index = 0; index < attachments.length; index++) {
        try {
            const response = await upload(attachments[index], (event) => {
                const fraction = event.total ? Math.min(event.loaded / event.total, 1) : 0;
                onProgress?.(Math.round((index + fraction) * 100 / attachments.length));
            });
            if (response?.response || response?.status < 200 || response?.status >= 300 || !response?.data || response.data.status === 'error' || response.data.success === false) {
                throw new Error('Не удалось загрузить файл');
            }
            onUploaded?.(response, attachments[index], index);
            onProgress?.(Math.round((index + 1) * 100 / attachments.length));
        } catch (cause) {
            const error = new Error(cause?.message || 'Не удалось загрузить файл');
            error.remainingFiles = attachments.slice(index);
            throw error;
        }
    }
};
